import React from 'react';
import { GAP_PLACEHOLDER } from '../lib/questionText';
import { button, hint, input, label as labelStyle } from '../../../shared/ui/formStyles';

// Поле для текста задания с кнопкой «Вставити пропуск»: подчёркивания не надо
// набирать руками — кнопка ставит их туда, где стоит курсор.
const SentenceInput = ({ value, onChange, title, placeholder }) => {
  const inputRef = React.useRef(null);
  const gapCount = String(value || '').split(GAP_PLACEHOLDER).length - 1;

  const insertGap = () => {
    const element = inputRef.current;
    const text = String(value || '');
    const start = element?.selectionStart ?? text.length;
    const end = element?.selectionEnd ?? start;

    const before = text.slice(0, start);
    const after = text.slice(end);
    const spaceBefore = before && !before.endsWith(' ') ? ' ' : '';
    const spaceAfter = after && !/^[\s.,!?;:]/.test(after) ? ' ' : '';
    const inserted = `${spaceBefore}${GAP_PLACEHOLDER}${spaceAfter}`;

    onChange(before + inserted + after);

    // Возвращаем курсор сразу за пропуск, чтобы можно было печатать дальше.
    const caret = (before + inserted).length;
    requestAnimationFrame(() => {
      if (!inputRef.current) return;
      inputRef.current.focus();
      inputRef.current.setSelectionRange(caret, caret);
    });
  };

  return (
    <div>
      <span style={labelStyle}>{title}</span>
      <div style={{ display: 'flex', gap: '8px', alignItems: 'flex-start' }}>
        <input
          ref={inputRef}
          type="text"
          value={value || ''}
          placeholder={placeholder}
          onChange={(e) => onChange(e.target.value)}
          style={input}
        />
        <button type="button" onClick={insertGap} style={{ ...button, whiteSpace: 'nowrap' }}>
          Вставити пропуск
        </button>
      </div>
      <p style={hint}>
        {gapCount === 0
          ? 'Поставте курсор туди, де має бути пропуск, і натисніть кнопку.'
          : `Пропусків у реченні: ${gapCount}. Студент вписує відповідь у поле під реченням.`}
      </p>
    </div>
  );
};

export default SentenceInput;
